import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { NavBarTab } from "./nav-bar-tab";

export const NavBarTabs = () => {
  const { isAuthenticated } = useAuth0();

  return (
    <div className="nav-bar__tabs">
      {/* {isAuthenticated && (
        <>
          <NavBarTab path="/profile" label="Profile" />
        </>
      )} */}
      <NavBarTab path="/stems" label="Stems" />
      {isAuthenticated && (
        <>
          <NavBarTab path="/profile" label="My Account" />
          {/* <NavBarTab path="/admin" label="Admin" /> */}
        </>
      )}
    </div>
  );
};
